module.exports = __webpack_public_path__ + "img/autoWind.dfd5c739.svg";